/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createStaticCurrencyFromDiscriminatorValue, type StaticCurrency } from '../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /currencies/inuse
 */
export interface InuseRequestBuilder extends BaseRequestBuilder<InuseRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<StaticCurrency[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<StaticCurrency[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InuseRequestBuilderUriTemplate = "{+baseurl}/currencies/inuse";
/**
 * Metadata for all the requests in the request builder.
 */
export const InuseRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: InuseRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createStaticCurrencyFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
